<template>
	<div class="slider-select-view">
		<input-view :value="_value" @click="toggle" />
		<popup-view ref="popup">
			<slider-view :value="value" @input="$emit('input', $event)" v-bind="$attrs"></slider-view>
		</popup-view>
	</div>
</template>

<script>
	export default {
		name: 'slider-select-view',
		props: ['value'],
		computed: {
			_value() {
				return this.$filters.number(this.value);
			}
		},
		methods: {
			toggle(event) {
				this.$refs.popup.toggle(event);
			}
		}
	}
</script>

<style lang="scss" scoped>
	.slider-select-view {
		display: inline-block;

		& > .input-view {
			cursor: pointer;
		}

		& > .popup-view {
			padding: 20px;

			& > .slider-view {
				width: 200px;
			}
		}
	}
</style>